var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGridBtnIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 6,
    fill: "#595959"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.77 19.75H23.73C21.72 19.75 20.75 18.86 20.75 17.02V12.48C20.75 10.64 21.73 9.75 23.73 9.75H27.77C29.78 9.75 30.75 10.64 30.75 12.48V17.01C30.75 18.86 29.77 19.75 27.77 19.75ZM23.73 11.25C22.39 11.25 22.25 11.63 22.25 12.48V17.01C22.25 17.87 22.39 18.24 23.73 18.24H27.77C29.11 18.24 29.25 17.86 29.25 17.01V12.48C29.25 11.62 29.11 11.25 27.77 11.25H23.73Z",
    fill: "#E8E8DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.77 31.25H23.73C21.72 31.25 20.75 30.27 20.75 28.27V24.23C20.75 22.22 21.73 21.25 23.73 21.25H27.77C29.78 21.25 30.75 22.23 30.75 24.23V28.27C30.75 30.27 29.77 31.25 27.77 31.25ZM23.73 22.75C22.55 22.75 22.25 23.05 22.25 24.23V28.27C22.25 29.45 22.55 29.75 23.73 29.75H27.77C28.95 29.75 29.25 29.45 29.25 28.27V24.23C29.25 23.05 28.95 22.75 27.77 22.75H23.73Z",
    fill: "#E8E8DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.27 19.75H12.23C10.22 19.75 9.25 18.86 9.25 17.02V12.48C9.25 10.64 10.23 9.75 12.23 9.75H16.27C18.28 9.75 19.25 10.64 19.25 12.48V17.01C19.25 18.86 18.27 19.75 16.27 19.75ZM12.23 11.25C10.89 11.25 10.75 11.63 10.75 12.48V17.01C10.75 17.87 10.89 18.24 12.23 18.24H16.27C17.61 18.24 17.75 17.86 17.75 17.01V12.48C17.75 11.62 17.61 11.25 16.27 11.25H12.23Z",
    fill: "#E8E8DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.27 31.25H12.23C10.22 31.25 9.25 30.27 9.25 28.27V24.23C9.25 22.22 10.23 21.25 12.23 21.25H16.27C18.28 21.25 19.25 22.23 19.25 24.23V28.27C19.25 30.27 18.27 31.25 16.27 31.25ZM12.23 22.75C11.05 22.75 10.75 23.05 10.75 24.23V28.27C10.75 29.45 11.05 29.75 12.23 29.75H16.27C17.45 29.75 17.75 29.45 17.75 28.27V24.23C17.75 23.05 17.45 22.75 16.27 22.75H12.23Z",
    fill: "#E8E8DB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridBtnIcon);
export default __webpack_public_path__ + "static/media/grid-btn-icon.ddc69b92d055211b5c6c50405b4fd1cc.svg";
export { ForwardRef as ReactComponent };